import { z } from 'zod/v3';

export type CodeOwnershipResult = {
  team: string;
  codeowners: string[];
  path: string;
};

export const codeOwnershipResultsApiResponseSchema = z.object({
  results: z.array(
    z.object({
      owners: z
        .array(
          z.object({
            ref: z.string(),
            count: z.number(),
          }),
        )
        .min(1),
      path: z.string(),
      expandable: z.boolean(),
      title: z.string(),
    }),
  ),
});
export type CodeOwnershipResultsApiResponse = z.infer<
  typeof codeOwnershipResultsApiResponseSchema
>;

export const codeOwnershipStatsApiResponseSchema = z.object({
  stats: z.array(
    z.object({
      glob: z.string(),
      count: z.number(),
    }),
  ),
});
export type CodeOwnershipStatsApiResponse = z.infer<
  typeof codeOwnershipStatsApiResponseSchema
>;
